import { create } from 'zustand';

const state = { userInfo: {} };

export const useUserInfo = create((set) => ({
    ...state,
    onChangeUserInfo: (newState) => set((state) => ({ ...state, ...newState })),
    onResetUserInfo: () => set(() => ({ ...state })),
}));
